<script lang="ts" setup>
import DirectionColumnIfMobileContainer from '../../DirectionColumnIfMobileContainer.vue';
import ResearchDataCard from '../../ResearchData/ResearchDataCard.vue';
import Img1 from '/home/runner/_work/shadow/shadow/packages/app/node_modules/.cache/home/runner/_work/shadow/shadow/packages/app/src/components/templates/ProductLpTemplate/mortgage/ResearchDataCard/2.jpeg/2.webp';
import PinchImageModal from '~theme/components/organisms/PinchImageModal.vue';

defineProps<{
  num: number;
}>();
</script>

<template>
  <ResearchDataCard :num="num" :class="$style.container">
    <template #title>
      マイホーム購入の障壁・懸念、<strong
        >過半数が「住宅ローンを毎月支払い続けられるか」を選択</strong
      >
    </template>
    <DirectionColumnIfMobileContainer>
      <PinchImageModal :src="Img1" alt="グラフ" />
      <div>
        <p>
          マイホームを所有したいと回答した方へ「マイホーム購入の際の障壁・懸念は何ですか」と質問したところ

          <strong
            >「住宅ローンを毎月支払い続けられるか」が47.0%と最も高く、将来の金銭面への不安、見通しがついていないことが懸念材料になり、</strong
          >マイホーム購入に踏み出せない人が少なくないようです。
        </p>
      </div>
    </DirectionColumnIfMobileContainer>
  </ResearchDataCard>
</template>

<style lang="scss" module>
.container {
  :nth-child(n + 2) {
    margin-top: 8px;
  }
}
</style>
